import { render, staticRenderFns } from "./Passwords.vue?vue&type=template&id=036ebd1c&scoped=true"
import script from "./Passwords.vue?vue&type=script&lang=js"
export * from "./Passwords.vue?vue&type=script&lang=js"
import style0 from "./Passwords.vue?vue&type=style&index=0&id=036ebd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ebd1c",
  null
  
)

export default component.exports